
// DROPDOWN See the format in cart page LSF
$('.dropdown-menu label').on('click', function(){
   $(this).parents('.dropdown').removeClass('open');
   var value = $(this).find('input').val();
   $('.dropdown-menu label').not(this).parents('li').removeClass('active');
   $('.dropdown-toggle .plc').text(value).addClass('bld');
});

$('.mobile-trigger-back').on('click', function(){
   $('.mobile-nav-bar').removeClass('menu-active')
   $('.mobile-nav-wrapper li').removeClass('mobile-active')
})
$('.mobile-nav-icon.trigger.all').on('click', function(){
   $('.mobile-nav-bar').removeClass('menu-active');
   $('.mobile-nav-wrapper li').removeClass('mobile-active');
})
$(document).ready(function() {
   //Floating menu (spy scroll)
   $(function() {
       var header = $(".megamenu-background");
       $(window).scroll(function() {
           var scroll = $(window).scrollTop();
           var distace  = 364;
           if (scroll >= distace) {
               header.addClass("fixed");
               if (scroll >= distace+40 ) {
                 header.addClass("show");
               } else {
                 header.removeClass("show");
               }
           } else {
               header.removeClass("fixed");
           }
       });
   });
});

$('.close-mega-sub-menu').click(function(){
 $('.with-sub-menu').removeClass('active');
 $(this).hide();
});

$('.with-sub-menu > a').click(function() {
 // Hide Collection on page menu
 //$(this).parents('.with-sub-menu').addClass('active');
 $('.type-menu-collection').removeClass('show-menu');
 setTimeout(function() {
   $('.close-mega-sub-menu').show();
 }, 500);
});

// ACTIVATE SMOOTH SCROLL FOR CHILD OF MAIN MENU THAT IS CURRENT
$("ul.megamenu > li.click li.activated li a").click(function(y) {
 var parent = $(this).parents('.with-sub-menu');
 parent.addClass('hide-submenu');
 $('.close-mega-sub-menu').hide();
 $('.type-menu-collection').addClass('show-menu');
 // Reactive main menu
 setTimeout(function() {
   parent.removeClass('active');
   parent.removeClass('hide-submenu');
 }, 500);
 // Smooth scroll is here
 var getId = $(this).attr("href").split('#');
 if(getId[1]){
    var C = '#'+getId[1];
    $("html,body").animate({
        scrollTop: $(C).offset().top - 100
    }, 800, "swing");
 }
});

// ACTIVATE URL FOR CHILD OF MAIN MENU THAT IS NOT CURRENT
$("ul.megamenu > li.click li.notactive a, ul.megamenu > li.click li.activated > a, a.mi-subimage--wrapper").click(function(y) {
 window.location = $(this).attr("href");
});

// SMOOTH SCROLL ALL URL WITH HASH #
if(window.location.hash) {
 var hash = window.location.hash;
 $('html, body').animate({
   scrollTop: $(hash).offset().top - 50
 }, 2000, 'swing');
}

// CLOSE BUTTON FOR MAIN MENU
$('body').click(function(evt){    
    if(evt.target.className == "sub-menu")
    return;
    
    //For descendants of menu_content being clicked, remove this check if you do not want 
    // to put constraint on descendants.
    if($(evt.target).closest('.sub-menu').length)
    return;             

    //Do processing of click event here for every element except with id menu_content
    $('.close-mega-sub-menu').hide();
});


$(document).ready(function() {
   // SHOW LOCATION FORM SIDEBAR
   $('.change_suburb').click(function(ev){
       ev.preventDefault();
       $('body').addClass('location-set-active');
       $(".moreless-button.custom_act").trigger('click');
   })
   $('.sidebar.get-suburb .icon-close a, .get-suburb-mask, #deliverytrigger1').click(function(ev){
       ev.preventDefault();
       $('body').removeClass('location-set-active');
   })

   // Variant selector radio
   $("input[name='variant-selector']").on("change", function() {
        var parent = $(this).parents('.selector-wrapper');
        var select = parent.find('select');
        // console.log(select)
        // update select
        select.val($(this).val());

        // manually trigger its change event
        select.trigger("change");

        // remove 'selected' class from all parents
        parent.find("input[name='variant-selector']").parent().removeClass("selected");

        // update text
        parent.find(".variant-text").html($(this).val());

        // add 'selected' class to the parent of the clicked radio
        $(this).parent().addClass("selected");
   });


   // SHOW FILTER COLLECTION
   $(".show-collection-filter").click(function(ev){
       ev.preventDefault();
       $("#sidebar-shadow").toggleClass('width-0');
       $("#sidebar").toggleClass('left-0');
       $("#col-main").toggleClass('width-100');
       $('.product-grid .col-xs-6').toggleClass('col-sm-3');
       $('.product-grid .col-xs-6').toggleClass('col-sm-4');
       $('.show-collection-filter').find('span').toggleClass('active');
       if($(document).innerWidth() < 767){
         $('.advanced-filter:not(.remove-filter)').hide();
         $('body').toggleClass('overflow-hidden');
       }
   })

   // ACTIVE COLLECTION ON PAGE MENU when scroll
   $(function() {
     var sections = $('section');
     var navigation_links = $('nav a');
     sections.waypoint({
     handler: function(direction) {
       var active_section;
       active_section = $(this);
       if (direction === "up") active_section = active_section.prev();
       var active_link = $('nav a[href="#' + active_section.attr("id") + '"]');
       navigation_links.parent().removeClass("active");
       active_link.parent().addClass("active");
       //active_section.addClass("active-section");
     },
     offset: '35%'
     });
   });


});

$('#playyoutube').on('click', function(ev) {
   $("#youtube-video")[0].src += "&autoplay=1";
   $('.tp-parallax-wrap').fadeOut(600, "linear", function() {
       $('.youtube-still').addClass("playing");
   });
   ev.preventDefault();
});

$('.playyoutube').on('click', function(ev) {
   ev.preventDefault();
   $(this).parents('.youtube-icon-trggr').toggleClass("playing")
   var youtubeVideo = $(this).attr("data-video");
   var caption = ".youtube-caption-"+youtubeVideo
   if ($(this).hasClass("ply")) {
       $(this).removeClass("ply");
       //pause
       $("#"+youtubeVideo)[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
       $("#"+youtubeVideo).fadeOut(500, "linear", function(){
           $(caption).fadeIn(500, "linear", function(){});
           //stop
           $("#"+youtubeVideo)[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
       });
   } else {
       $(this).addClass("ply");
       $("#"+youtubeVideo)[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
       $(caption).fadeOut(500, "swing", function(){
           $("#"+youtubeVideo).fadeIn(500, "swing", function(){});
       });
   }
});

$('.slide-body').on("mouseenter", ".youtube-icon-trggr.playing", function() {
   $(this).find('a').show()
});
$('.slide-body').on("mouseleave", ".youtube-icon-trggr.playing", function() {
   $(this).find('a').hide()
});



// TRAMPOLINE SPRINGLESS and SPRING FILTER PAGE
$('.content-accordion h3').click(function() {
 $(this).siblings('ul').slideToggle('fast');
 $(this).find('i').toggleClass('aDown');
 $('.select-size-container').toggleClass('adjust');
 return false;
});

$( "#listTrampolines li" ).click(function() {
 var size =  '.'+$(this).attr("data-value");
 var sizeText = $(this).html();
 $('.springsizes.clearfix .fifth').hide();
 $(size).show();
 $("#sizeText").html(sizeText);
 $('.dropdown').removeClass('open');
 $('.select-size-container').removeClass('adjust');
});

// FOR PARALLAX SO THAT IT WILL NOT BREAK WHEN RESIZE AND LOAD
var timer;
$(window).bind('resize', function() {
clearTimeout(timer);
timer = setTimeout(function(){ $(window).resize(); }, 250);
});
var timer;
$(window).bind('load', function() {
clearTimeout(timer);
timer = setTimeout(function(){ $(window).load(); }, 250);
});


// Postage calculator #04 (click go)

// Postage calculator #05 (ajax call...)

function updatePriceeeee(e) {
    var uniqRates = e;

    $('.location_set_info').find(".info strong").text(locationObj.suburb.replace(/\+/, ' ')+', '+locationObj.state+' '+locationObj.postcode);
    void 0 === e == 0 ? (jQuery(window).trigger("resize").trigger("scroll"), 
    $(".premium_diverse-container").hide(), 
    $('.location-unknown').find(".location_set_info").show(), 
    $('.location-unknown').find(".location_information").hide(), 
    $(".delivery-check-result").show(), 
    $(".delivery-check-result .rate").html("Not Available"), 
    $(".delivery-check-result #regular").html("Please contact us for a quote"), 
    $(".default-hide.cart-page").hide(), 
    $("#noprice").hide(), 
    $.getJSON("https://lifespanonline.com.au/postage-query/info/delivery-information.json", (function(response) {
        // Step 1: Group by type
        const grouped = uniqRates.reduce((acc, item) => {
            if (item.type === "pickup" && item.total_price === 0) {
                // Can be used to display pickup
                return acc; // do not add this item
            }
            const key = item.type;
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(item);
            return acc;
        }, {});
        // Sort each group by total_price ascending
        Object.keys(grouped).forEach(key => {
            grouped[key] = grouped[key].sort((a, b) => a.total_price - b.total_price);
        });
        // console.log(grouped)

        // Step 2: Define order as array of objects with type + default
        const order = [
          { type: "regular", default: {text: "Big & Bulky Economy Delivery (Standard)", value: "Please contact us for a quote"}},
          { type: "express", default: {text: "Big & Bulky Economy Delivery (Express)", value: "Not Available"}},
          { type: "regular|premium", default: {text: "Big & Bulky Room of Choice Delivery", value: "Not Available"}},
          { type: "express|premium|diverse", default: {text: "Big & Bulky Room of Choice Delivery + Install", value: "Not Available"}},
          { type: "pickup", default: false }
        ];

        // Step 3: Iterate with fallback
        order.forEach(({ type, default: dft }) => {
          const items = grouped[type];
          const typeClass = type.replace(/\|/g, "_");
          if (items && items.length > 0) {
            var htmlWithCarrier = createHtmlElm(response, typeClass, items);
            $('.delivery-check-result.result-auto').append(htmlWithCarrier);
          } else {
            if (dft) {
                var no_carrier = [{
                    carrier_name: '',
                    display_code: dft.text,
                    total_price: dft.value
                }]
                var htmlWithCarrierr = createHtmlElm(response, typeClass, no_carrier)
                $('.delivery-check-result.result-auto').append(htmlWithCarrierr);
            }
          }
        });
    }))
    ) : ($('.location-unknown').find(".location_set_info").hide(), $('.location-unknown').find(".location_information").show(), $(".delivery-check-result").hide(), $(".check-result-container").append('<p id="noprice" style="font-size:13px;">Please contact us via online chat or phone for a tailored shipping quote. </p>')), $(".delivery-pickup .spinner-1").hide(), $('.get-suburb .spinner-1').hide(), $(".clearfix").find(".pull-right").trigger('click'), $(".check-result-container").slideDown("slow"), $(".moreless-button").show();  
    if ($("body").hasClass("suburb_found")) {
        $('.get-suburb .spinner-1').hide();
        $('.change_button button').trigger('click');
    } else {
     // $(".check-result-container").slideDown("slow");
    }
}


// CHECK IF THIS IS CART PAGE
if ($('.this-is-cart-page').length != 0 ) {
   // QTY COUNTER
   $(".q_up").unbind("click"), $(".q_up").on("click", function() {
       var C = $(this).data("product_id"),
           S = parseInt($(".quantity-cart-" + C).val()) + 1;
       $(".quantity-cart-" + C).val(S);

   }), $(".q_down").unbind("click"), $(".q_down").on("click", function() {
       var C = $(this).data("product_id"),
           S = parseInt($(".quantity-cart-" + C).val());
       1 < S && $(".quantity-cart-" + C).val(S - 1)
 })
}

// Stock Availability in each store #02 (Quantity)
function getQuantityDataaaa(logResults){
 var isMulti = $('.sku').attr('data-multisku');
 var url;
 if (isMulti == 'false') {
   var sku = $('.sku').text();
 } else {
   var sku = $('.sku').attr('data-skus');
 }
 var data;
 $.ajax({
   url: "https://1117015.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=623&deploy=1&compid=1117015&ns-at=AAEJ7tMQkyX-9quosAYuoRdLWndgI5fkODhy5BL-FR50CUontp0&item_key_type=sku&item_keys="+sku+"&location=15,10,9&jsonp=y",
   type: "get",
   crosscallDomain: true,
   dataType: "jsonp",
   jsonpCallback: "logResults",
   success: function (resp) {
     //console.log("resp",resp);
     data = resp;
     // console.log(data.inventory)
     logResults(data.inventory);
   },
   error: function () {}
 });
}


// Stock Availability in each store #03 (Display)
function pickUpLocationnn(){
    console.log('still executed');
 var i;
 getQuantityData(function(dataQuantity) {
   if (dataQuantity.length == 1) {
     var d = dataQuantity[0].inventory;
     for (var l = 0; l < d.length; l++) {
       var locationId = '.location-'+d[l].inventory_location_id;
       if (d[l].location_quantity_available < 10 ) {
         if (d[l].location_quantity_available < 1 ) {
           $("#dynamicPickUpResult "+locationId).addClass('out-stock');
           $("#dynamicPickUpResult "+locationId).html('<span class="radar"><span class="circle"></span></span>Out of Stock');
         } else {
           $("#dynamicPickUpResult "+locationId).addClass('low-stock');
           $("#dynamicPickUpResult "+locationId).html('<span class="radar"><span class="circle"></span></span>Limited Stock');
         }
       }else{
         $("#dynamicPickUpResult "+locationId).addClass('in-stock');
         $("#dynamicPickUpResult "+locationId).html('<span class="radar"><span class="circle"></span></span>In Stock');
       }
     }
   }

   if (dataQuantity.length > 1) {
     for (var k = 0; k < dataQuantity.length; k++) {
       var sku = dataQuantity[k].sku.replace('.', '-');
       for (var m =  0; m < dataQuantity[k].inventory.length; m++) {
         // Minimise loading time we only process the exact location id
         var locId = dataQuantity[k].inventory[m].inventory_location_id;
         if (locId == '15' || locId == '10' || locId == '9') {
           var invQuant = dataQuantity[k].inventory[m].location_quantity_available;
           var locationId = '.location-'+locId+'.'+sku;
           if (invQuant < 10 ) {
             if (invQuant < 1 ) {
               $("#dynamicPickUpResult "+locationId).addClass('notavailable');
               $("#dynamicPickUpResult "+locationId).text('Out of Stock');
             } else {
               $("#dynamicPickUpResult "+locationId).text('Limited Stock');
               $("#dynamicPickUpResult "+locationId).addClass('limited-stock');
             }
           }else{
             $("#dynamicPickUpResult "+locationId).addClass('available');
             $("#dynamicPickUpResult "+locationId).text('In Stock');
           }
           // if (invQuant == 5) {
           //   console.log(locationId+' ===== '+invQuant);
           //   $("#dynamicPickUpResult "+locationId).text('notavailable');
           // }
         }
       }
     }
   }
 });
}


// WHEN POSTCODE OR SKU is incorrect
function showError(data){
 jQuery(window).trigger('resize').trigger('scroll');
 $('.delivery-pickup .spinner-1').hide();
 // $('.check-result-container').slideDown('slow');
 // $(".moreless-button").show();
 $(".clearfix").find(".pull-right").trigger('click');
 var i;
 for (i = data.length - 1; i >= 0; i--) {
   $('.delivery-check-result').html("<p style='color: #F8ACAC'>"+data[i]+"</p>");
 }
}

// PRODUCTS PAGE
$('.trigger-delivery-info').click(function(){
 $(this).toggleClass('active');
 var target = $(this).attr('data-target');

 $('.delivery-info.'+target).toggleClass('hide');
 $('.delivery-info:not(.'+target+')').addClass('hide');
 $('.trigger-delivery-info').not(this).removeClass('active');
});


// COLLECTION WHEN TYPE-MENU CLICKED
$('.type-menu-collection li').click(function(){
 $('.type-menu-collection li').removeClass('active');
 $(this).addClass('active');
 $('.collection-nav-mob').removeClass('open');
});

$(function() {
   var header = $(".type-menu-collection");
   $(window).scroll(function() {
       var scroll = $(window).scrollTop();
       var distace  = 420;
       if (scroll >= distace) {
           header.addClass("fixed");
           if (scroll >= distace+40 ) {
             header.addClass("show-menu");
           } else {
             header.removeClass("show-menu");
           }
       } else {
           header.removeClass("fixed");
       }
   });
}); 


// PAGES
$('body').on('click', '.collapse-trigger', function(e) {
 e.preventDefault();
 if ($(this).hasClass('with-icon')) {
   $(this).find('i').toggleClass('aDown');
 }
 $(this).parents('.collapse-container').toggleClass('reveal');
 $(this).siblings('.collapse-hide').slideToggle('slow');
});


$('.file-input-modified input').each(function(){
 var $input   = $(this);
 var $label   = $input.next('label');
 var labelVal = $label.html();

 $('.file-input-modified').on('change', 'input', function(e){
   var fileName = '';
   if(e.target.value)
     fileName = e.target.value.split( '\\' ).pop();
   if(fileName)
     $(this).siblings('label').find('.fn').html(fileName);
   else
     $label.html(labelVal);
 });

 // Firefox bug fix
 $input
 .on('focus', function(){ $input.addClass('has-focus');})
 .on('blur', function(){ $input.removeClass('has-focus'); });
});

// Javascript to enable link to tab
var url = document.location.toString();
if (url.match('#')) {
 var target = '#'+url.split('#')[1];
 const tabDestination = $('.nav-tabs a[href="' + target + '"]');
 if ($(target+'.tab-pane').length  > 0) {
   const tabDestination = $('.nav-tabs a[href="' + target + '"]');
 } else {
   // content inside tab
   target = '#'+$(target).attr('data-parenttab');
   const tabDestination = $('.nav-tabs a[href="' + target + '"]');
 }
 tabDestination.tab('show');
 tabDestination.addClass('disabled');
 $('#nav-tabContent .tab-pane.active:not('+target+')').addClass('force-hide');
 $('#nav-tabContent '+target).addClass('force-show');
} 
$('.nav-tabs a').on('click', function() {
 if ($(this).hasClass('disabled')) {
   return;
 } else {
   $('#nav-tabContent .tab-pane').removeClass('force-hide force-show');
   $('.nav-tabs a').removeClass('disabled');
 }
});

function boMssgChange(el){
   // HOW To >> 1. input linebackorder as previous sibling, 2. add class product id to class variant-inv
   var selectedVariant = '.'+$(el).find('option:selected').text()+'_'+el.value;
   // Back order message
   $('.'+el.attributes.id.value+' li').addClass('hide');
   $('.'+el.attributes.id.value+' li'+selectedVariant).removeClass('hide');

   //line properties
   var lineValue = $('.variant-inv li'+selectedVariant).text();
   el.previousElementSibling.value = lineValue;
}
$(".mega-stores li a").click(function(){
   event.preventDefault(); 
   var store = $(this).attr('data-target');
   if (store != 'false') {
       $(store).click(); 
       var C = '#map-canvas';
       $("html,body").animate({
           scrollTop: $(C).offset().top - 100
       }, 800, "swing");
   }
});

$('body').on('click', '.store-list li', function(e) {
   var C = '#map-canvas';
   $("html,body").animate({
       scrollTop: $(C).offset().top - 100
   }, 800, "swing");

});

$(document).ready(function() {
    let currentIndex = 0;
    const slides = $('.slides li');
    const dots = $('.dot');
    let getSpeed = $(".home-slider-content").attr("data-slider_interval");
    const slideCount = slides.length;

    function goToSlide(index) {
        slides.removeClass('active').eq(index).addClass('active');
        dots.removeClass('active').eq(index).addClass('active');
        currentIndex = index;
    }
    // Initialize
    goToSlide(currentIndex);
  
    // Automatic sliding (optional)
    setInterval(function() {
        const nextIndex = (currentIndex + 1) % slideCount;
        goToSlide(nextIndex);
    }, getSpeed); // Change slide every 3 seconds

    if ($("body").hasClass("templateProduct")) {
        if (window.innerWidth < 768) {
          // console.log("mobile");
          const customEntry = document.querySelector(".custom-entry");
          const productFocusContainer = customEntry.querySelector(".product-focus-container");
          if (productFocusContainer) {
              console.log("productFocusContainer", productFocusContainer);
              productFocusContainer.remove(); // Directly remove the element
          }
        } else {
          // console.log("desktop");
          const productImagesWrapper = document.querySelector(".product-images-wrapper");
          const mobileTitle = productImagesWrapper.querySelector(".mobile-title");
          if (mobileTitle) {
              mobileTitle.remove(); // Directly remove the element
          }
        }
    };

    // Menu change image on hover
    var imgCurrent = '';
    const preloadedImages = {};
    $('.menu li.type li a').hover(function () {
        const imgContainer = $(this).parents('.link-has-child').prev().find('.mi-image');
        const imgSrc = $(this).data('img');
        // console.log('--------');
        // console.log(imgCurrent);
        // console.log(imgSrc)
        // console.log('----------------');
        if($(this).text() != 'View All' && imgCurrent != imgSrc){
            imgCurrent = imgSrc;
            $(this).parents('.link-has-child').find('li').removeClass('hovered');
            $(this).parent().addClass('hovered');
            const img = new Image();
            img.onload = function () {
                imgContainer.fadeOut(100, function () {
                    $(this).html(`<img src="${imgSrc}" alt="Menu Image">`).fadeIn(200);
                });
                preloadedImages[imgSrc] = img; // Optional caching
            };

            img.onerror = function () {console.warn(`Image not found: ${imgSrc}`)};
            img.src = imgSrc;

            // Force onload for cached images
            if (img.complete && img.naturalHeight !== 0) {
                img.onload(); // ensures immediate swap if already loaded
            }
        }
    });

});

